import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '@src/store/store'
import { setIsHeader } from '@src/store/ducks/app/reducer'
import { PaymentForm } from '@src/components/PaymentForm/PaymentForm'
import useQuery from '@src/hooks/useQuery'
import { getAccounts } from '@src/store/ducks/user/thunks'
import style from './Pay.module.scss'

export const Pay = () => {
  const dispatch = useDispatch<AppDispatch>()
  const sum = useQuery('sum')
  const token = useQuery('token')
  const payId = useQuery('payid')

  useEffect(() => {
    if (token) {
      sessionStorage.setItem('token', token)
      dispatch(getAccounts())
    }
    dispatch(setIsHeader(false))
  }, [dispatch, token])

  return (
    <div className={style.container}>
      <div className={style.content}>
        <PaymentForm sum={sum ? +sum : undefined} payId={payId} />
      </div>
    </div>
  )
}
